module.exports = __webpack_public_path__ + "static/media/63-iveco.e60e3063.jpg";